import { combineReducers } from 'redux';
import journey from './journey';
import persistedAt from './persistedAt';

export const financialEducation = combineReducers({
    journey,
    persistedAt
})
